import classnames from 'classnames';

const CrewLeaderHeader = ({ crewLeaders }) => {
  return (
    <div className="fc-day-header">
        {crewLeaders.map(worker => (
        <div key={worker._id} className="schedule-v6-cl-header-wrapper">
            <div
              className={classnames(
                'schedule-v6-chip', 'schedule-v6-chip--worker',
                worker?.profile?.shifts?.timeOfDay?.toLowerCase(),
              )}
            >
              {worker?.username}
            </div>
          </div>
        ))}
      <div className="schedule-v6-cl-header-rest"/>
    </div>
  )
};

export default CrewLeaderHeader;